class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.applyCategoryIntent.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this))
    }
  }

  // Native collection scope keeps category/brand products and facets in agreement.
  applyCategoryIntent(event) {
    const path = window.ProHairDiscovery?.destination(this.input.value.trim());
    if (!path) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const context = new URLSearchParams();
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) context.set('preview_theme_id',preview);
    location.assign(window.ProHairDiscovery.withFilters(path,context));
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return true;
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Explicit Clear must work even when a suggestion is highlighted.
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
